import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetOrder } from '../../actions/currentOrder';

const initialState = null as string | null;

const slice = createSlice({
  name: '$pickupTime',
  initialState,
  reducers: {
    setPickupTime(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetOrder, (_state, _action) => {
      return initialState;
    });
  },
});

export const { setPickupTime } = slice.actions;
export default slice.reducer;
